import {
  Button,
  Col,
  Row,
  Space,
  Table,
  Input,
  Form,
  notification,
  Spin,
  Popover,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { receivedTableDataSource, fields, columns } from "./data.config";
import Icons from "assets/icons";
import "./Pending.scss";
import { DataType } from "types/models/refractive-type";
import { receivedColumns } from "types/config/colums-refractive";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  InputFields,
  ListActionButton,
} from "components/common";
import { payService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setActiveKey, setIdPhieuKham } from "redux/reducer/common";
import { FORMAT_TIME, tabKeys } from "types/enums";
import {
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import { TableRowSelection } from "antd/es/table/interface";
import { catalogService } from "api";
import { CalendarSVG, CalendarSelectedSVG, ListIconSVG } from "assets";
import dayjs from "dayjs";
import moment from "moment";
import Notification from "components/common/notification/notification";
import { setId } from "redux/reducer/reduxCommon";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { ColumnProps } from "types/models";

const PendingTab = () => {
  let savedTableOption = getTableOptions(
    "PAY_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? columns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columns;
  const [column, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter((e) => e.show == true)
  );
  const activeKey = useAppSelector((state) => state.common.activeTab);
  const [data, setData] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [loading, setLoading] = useState(false);
  const expandRef = useRef<any>();
  const [form] = Form.useForm();
  const [dataFields, setDataFields] = useState(fields);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const disPath = useAppDispatch();
  const [selectedBtn, setSelectedBtn] = useState<number | null>(1);
  const callApi = useAppSelector((state) => state.reduxCommon.callApi);
  const [params, setParams] = useState<any>({
    limit: 50,
    page: 1,
    ngayBatDau: dayjs(),
    ngayKetThuc: dayjs(),
    // comboboxNgay: 0,
    // checkboxTrangThai: 0,
  });

  const label = [
    {
      key: 1,
      value: "Hôm nay",
      onclick: (e) => onToday(e),
    },
    {
      key: 2,
      value: "Hôm qua",
      onclick: (e) => onYesterday(e),
    },
  ];

  const onToday = (key: number) => {
    setLoading(true);
    setParams({ ...params, ngayKetThuc: dayjs(), ngayBatDau: dayjs() });
    setSelectedBtn(key);
  };

  const onYesterday = (key: number) => {
    setLoading(true);
    setParams({
      ...params,
      // comboboxNgay: 2,
      ngayKetThuc: dayjs().subtract(1, "day"),
      ngayBatDau: dayjs().subtract(1, "day"),
    });

    setSelectedBtn(key);
  };

  useEffect(() => {
    getListKhuKham();
    getListTTBH();
    getListLoaiKCB();
  }, [params, callApi]);

  const handlePaginationChange = (page, pageSize) => {
    // setCurrentPage(page);
    // setPageSize(pageSize);
    setParams({
      ...params,
      page: page,
      limit: pageSize,
    });
  };

  const paginationConfig = {
    current: params.page,
    total: totalPage,
    pageSize: params.limit,
    onChange: handlePaginationChange,
  };

  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayBatDau: formatDateToString(params.ngayBatDau),
      ngayKetThuc: formatDateToString(params.ngayKetThuc),
    };
  };

  useEffect(() => {
    onSearch();
  }, [params, callApi, activeKey, activeKey]);

  //search
  const onSearch = () => {
    // console.log("data clean", formatParams());
    setLoading(true);
    const param = {
      page: params.page,
      limit: params.limit,
    };
    try {
      const response = payService
        .searchPatient(formatParams(), param)
        .then((res) => {
          // console.log("res tim kiem danh sach thanh toan", res);
          // notification.success({message: "Lấy dữ liệu thành công"});
          const newData = res.data.data.map((item) => ({
            ...item,
            key: item.id,
            name: item.hoVaTen,
            mpk: item.maKhamBenh,
            mbn: item.maBenhNhan,
            gender: item.gioiTinh,
            born: item.ngaySinh,
            tttt: item.idTrangThaiThanhToan,
            address: item.diaChi,
            kcb: item.idLoaiKhamChuaBenh,
            bhyt: item.soTheBaoHiemYTe,
            ttbh: item.idTrangThaiBaoHiem,
          }));
          setData(newData);
          setLoadingTable(false);
          setLoading(false);
          setTotalPage(res.data.total);
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách thanh toán");

      setLoading(false);
      setLoadingTable(false);
    }
  };

  const renderLoaiKCB = (listKCB) => {
    column.find((e) => e.dataIndex == "kcb").render = (v, r, i) => {
      let textKCB = listKCB.find((e) => e.id == v)?.tenLoaiKCB;
      return <KCBTypeColumn label={textKCB}></KCBTypeColumn>;
    };
  };

  column.map((e) => {
    if (e.key == "action") {
      e.render = (_, record, index) => {
        return (
          <ListActionButton
            editFunction={() => handleOnEdit(record)}
            // printFunction={() => handleOnPrint(record)}
            deleteFunction={() => handleOnDelete(record)}
          ></ListActionButton>
        );
      };
    }
    if (e.key == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (params.page - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const handleOnPrint = (record) => {};

  const handleOnDelete = async (record) => {
    setLoadingTable(true);
    try {
      const response = await payService
        .deletePatient(record.key)
        .then((res) => {
          Notification("success", "Thao tác thành công");
        });
      setLoadingTable(false);
    } catch (error) {
      setLoadingTable(false);

      Notification("error", "Đã có lỗi xảy ra khi xoá");
    }
    onSearch();
  };

  const handleOnEdit = (record) => {
    // console.log("data record", record);
    disPath(setIdPhieuKham(record.maKhamBenh));
    disPath(setId(record.key));
    disPath(setActiveKey(tabKeys.PAY.PAY_TAB));
    // setIsPayTabDisabled(false);
  };

  const getListKhuKham = async () => {
    try {
      const res = await catalogService.getListKhuKham();
      dataFields.find((e) => e.name == "idKhuKhamChuaBenh").options = res.map(
        (e) => {
          return { value: e.id, label: e.tenKhuKham };
        }
      );
      setDataFields([...fields]);
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách khu khám");
    }
  };

  const getListLoaiKCB = async () => {
    try {
      const res = (await catalogService.getListLoaiKCB()) || [];

      dataFields.find((e) => e.name == "loaiKhamChuaBenh").options = res.map(
        (e) => {
          return { value: e.id, label: e.tenLoaiKCB };
        }
      );
      column.find((e) => e?.dataIndex == "kcb").render = (v, r, i) => {
        const kcb = res.find((e) => e?.id == v)?.tenLoaiKCB;

        return <>{kcb}</>;
      };
      renderLoaiKCB(res);
      setDataFields([...fields]);
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách loại khám chữa bệnh"
      );
    }
  };

  const getListTTBH = async () => {
    try {
      const res = await catalogService.getListTTBH();

      dataFields.find((e) => e.name == "idTrangThaiBaoHiem").options = res.map(
        (e) => {
          return { value: e.id, label: e.tenTrangThaiBH };
        }
      );
      setDataFields([...fields]);
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách trạng thái bảo hiểm"
      );
    }
  };

  const onClickSearchButton = () => {
    var searchFields = expandRef.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 });
  };

  const handleRowClick = (record) => {
    handleOnEdit(record);
  };

  const onSelectChange = (selectedRowKeys: React.Key[], selections) => {
    setSelectedRowKeys(selectedRowKeys);
    disPath(setIdPhieuKham(selections[0].maKhamBenh));
    disPath(setId(selectedRowKeys[0]));
    // disPath(setIdPhieuKham(res?.data?.id));
  };

  const rowRadio: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: "radio",
  };

  // const onReset = () => {
  //   var searchFields = expandRef.current?.getData();
  //   setParams({
  //     ...params,
  //     ...searchFields,
  //     page: 1,
  //     ngayBatDau: formatDateToString(params.ngayBatDau),
  //     ngayKetThuc: formatDateToString(params.ngayKetThuc),
  //   });
  // };

  const onKeyDown = (e) => {
    if (e.key == "Enter") {
      onClickSearchButton();
    }
  };

  const setShowColumns = (showColumns) => {
    saveTableOptions(
      "PAY_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  return (
    <Spin spinning={loading}>
      <div id="pending-tab" onKeyDown={onKeyDown}>
        <Space direction="vertical" size={24} style={{ width: "100%" }}></Space>
        <div className="container">
          <Space direction="vertical" style={{ width: "100%" }}>
            <ExpandSearch
              fields={dataFields}
              ref={expandRef}
              onClickSearch={onClickSearchButton}
              onReset={onClickSearchButton}
              initialValues={params}
            ></ExpandSearch>
          </Space>
        </div>
        <div className="container">
          <Row
            style={{ marginBottom: "10px" }}
            justify={"end"}
            gutter={[16, 8]}
          >
            <Space>
              {label.map((item) => (
                <Button
                  key={item.key}
                  onClick={() => {
                    item.onclick(item.key);
                  }}
                  className={
                    item.key === selectedBtn ? "btn-sub" : "custom-btn"
                  }
                  icon={
                    item.key === selectedBtn ? (
                      <CalendarSelectedSVG />
                    ) : (
                      <CalendarSVG />
                    )
                  }
                >
                  {item.value}
                </Button>
              ))}
              <Popover
                trigger="click"
                placement="bottomLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
            </Space>
          </Row>
          <CustomResizableTable
            setShowColumns={setShowColumns}
            // className="custom-resize-table-scroll"
            bordered
            columns={column}
            dataSource={data}
            // scroll={{ x: 1500 }}
            pagination={paginationConfig}
            loading={loadingTable}
            rowSelection={rowRadio}
            onRow={(record) => ({
              onDoubleClick: () => handleRowClick(record),
            })}
          />
        </div>
      </div>
    </Spin>
  );
};

export default PendingTab;
